import { ListProductReference } from '@epicuro-next/data/lists';
import {
  UBCMessage,
  UBCMessageName,
} from '@epicuro-next/state/ubc-communication/core';
import { createAction, props } from '@ngrx/store';

export interface ShopTheCommercialListPayload {
  listId: string;
  lookBookId?: string;
  productReferences: ListProductReference[];
  overrideRequestedDeliveryDateForAllISO?: string;
}

export const shopTheCommercialList = createAction(
  '[UBC Commercial List] Shop the commercial list',
  props<
    UBCMessage<
      UBCMessageName.ShopTheCommercialList,
      ShopTheCommercialListPayload
    >
  >(),
);
